import React, { useState } from "react";
import { Entity } from "@common/types/entity";
import { useEntities } from "@hooks/useEntities";
import { Button } from "@design-system/Button/Button";
import { StandardModalBody } from "@design-system/Modal/Modal";
import { HStack } from "@design-system/HStack/HStack";
import { EntitySelect } from "./EntitySelect";

interface Props {
    prompt?: string;
    onCancel: () => void;
    onSelected: (entity: Entity) => void;
    selectPlaceholder?: string;
}

export const SelectBusinessEntityModal: React.FC<Props> = ({
    prompt = "Select business entity",
    onCancel,
    onSelected,
    selectPlaceholder = "Select entity",
}) => {
    const businessEntities = useEntities({ onlyBusiness: true });
    const [selected, setSelected] = useState<Entity | undefined>(
        businessEntities?.[0],
    );

    return (
        <StandardModalBody>
            <p className="text-prominent mr-4">{prompt}</p>
            <EntitySelect
                entities={businessEntities ?? []}
                selectedEntity={selected}
                onChange={setSelected}
                placeholder={selectPlaceholder}
                triggerButtonProps={{ variant: "primary", block: true }}
            />

            <HStack as="footer" justify="end" gap={12} className="mt-4">
                <Button variant="secondary" size="md" onClick={onCancel}>
                    Cancel
                </Button>
                <Button
                    variant="primary"
                    size="md"
                    disabled={!selected}
                    onClick={() => onSelected(selected!)}
                >
                    Confirm
                </Button>
            </HStack>
        </StandardModalBody>
    );
};
